import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@/components/ThemeProvider";
import { AppProvider } from "@/lib/appContext";
import Layout from "@/components/Layout";
import GaTracker from "@/components/GaTracker";
import Home from "@/pages/Home";
import LandConverter from "@/pages/LandConverter";
import PlotCalculator from "@/pages/PlotCalculator";
import RectangleCalculator from "@/pages/RectangleCalculator";
import CircleCalculator from "@/pages/CircleCalculator";
import TriangleCalculator from "@/pages/TriangleCalculator";
import StampDuty from "@/pages/StampDuty";
import RegistryCost from "@/pages/RegistryCost";
import ConstructionCost from "@/pages/ConstructionCost";
import WarehouseRental from "@/pages/WarehouseRental";
import FARCalculator from "@/pages/FARCalculator";
import LoanEMI from "@/pages/LoanEMI";
import PercentageCalculator from "@/pages/PercentageCalculator";
import Favorites from "@/pages/Favorites";
import History from "@/pages/History";
import NotFound from "@/pages/NotFound";
import PropertyTax from "@/pages/PropertyTax";
import RentalYield from "@/pages/RentalYield";
import LoanEligibility from "@/pages/LoanEligibility";
import CostPerSqft from "@/pages/CostPerSqft";
import CropYield from "@/pages/CropYield";
import PropertyROI from "@/pages/PropertyROI";
import MapArea from "@/pages/MapArea";

function App() {
  return (
    <AppProvider>
      <ThemeProvider>
        <BrowserRouter>
          <GaTracker />
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="map-area" element={<MapArea />} />
              <Route path="land-converter" element={<LandConverter />} />
              <Route path="plot" element={<PlotCalculator />} />
              <Route path="rectangle" element={<RectangleCalculator />} />
              <Route path="circle" element={<CircleCalculator />} />
              <Route path="triangle" element={<TriangleCalculator />} />
              <Route path="stamp-duty" element={<StampDuty />} />
              <Route path="registry" element={<RegistryCost />} />
              <Route path="construction" element={<ConstructionCost />} />
              <Route path="cost-sqft" element={<CostPerSqft />} />
              <Route path="warehouse-rent" element={<WarehouseRental />} />
              <Route path="far" element={<FARCalculator />} />
              <Route path="loan-emi" element={<LoanEMI />} />
              <Route path="loan-eligibility" element={<LoanEligibility />} />
              <Route path="percentage" element={<PercentageCalculator />} />
              <Route path="property-tax" element={<PropertyTax />} />
              <Route path="rental-yield" element={<RentalYield />} />
              <Route path="property-roi" element={<PropertyROI />} />
              <Route path="crop-yield" element={<CropYield />} />
              <Route path="favorites" element={<Favorites />} />
              <Route path="history" element={<History />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </AppProvider>
  );
}

export default App;
